import $ from 'jquery';
import Slick from './slick';

/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */

const toggleMenu = (event) => {
    event.preventDefault();
    $('.js-menu-toggle, .nav--header').toggleClass('open');
    $('.header').toggleClass('menu-open');
};

$('.js-menu-toggle').on('click', toggleMenu);


$(document).ready(function(){

  // slick
  $('[data-slider="hero"]').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    fade: true,

  });

  // one image out of 10
  var $status = $('.pagingInfo');
  var $slickElement = $('[data-slider="modal"]');

  $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + ' of ' + slick.slideCount);
  });

  $slickElement.slick({
      autoplay: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.slick-arrow.slick-prev'),
      nextArrow: $('.slick-arrow.slick-next'),
      fade: true,
      asNavFor: '[data-slider="modal-nav"]',
      pauseOnHover: false,
  });

  // hide prev and next partial slides
  var $slickFrame = $('[data-slider="modal-nav"] .slick-list');

  var slideWidth = $slickFrame.width() / 3;
  var centerPadding = (slideWidth / 4) * 3;

  $('[data-slider="modal-nav"]').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '[data-slider="modal"]',
    focusOnSelect: true,
    centerMode: true,
    centerPadding: centerPadding + 'px'
  });
});



$('[data-slide]').click(function() {
  var slideno = $(this).data('slide');
  $('[data-slider="modal-nav"]').slick('slickGoTo', slideno - 1);
  $('[data-modal="gallery"]').fadeIn();
  $('[data-slider="modal-nav"]').slick('setPosition');
  $('[data-slider="modal"]').slick('setPosition');
  $(this).parents('.section--gallery').fadeOut();
  $('.section--hero').fadeOut();
  $('html, body').animate({
      scrollTop: 0
  }, 500);
});

$('.close--modal').click(function(){
  $('.section--hero').fadeIn();
  $('.section--gallery').fadeIn();
  $('[data-modal="gallery"]').fadeOut();
});

$('.filter__header h2').click(function() {
  $(this).next().slideToggle().toggleClass('open');
  $('.filter__header, .filter__header h2').toggleClass('open');
});
